// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S5CZ","name":"styles_name__21FL1","phone":"styles_phone__TO9i6"};